<template>
  <v-dialog
    v-model="dialog"
    max-width="700"
    persistent
    scrollable
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="black"
        dark
        v-on="on"
        @click="dialog = true"
      >
        <v-icon small left>mdi-link</v-icon> Apensar
      </v-btn>
    </template>

    <v-card>
      <v-toolbar flat>
          <v-toolbar-title>
            <v-icon>mdi-link</v-icon>
            <span>Apensar Processo</span>
          </v-toolbar-title>
        </v-toolbar>

        <v-card-text class="px-4">
          <v-combobox
            v-model="searchResult"
            :search-input.sync="search"
            :items="folders"
            item-text="process_number"
            prepend-inner-icon="search"
            label="Buscar e Apensar Processo"
            no-data-text="Processo não encontrado"
            @change="addFolder"
            :loading="loadingSearch"
          >
            <template v-slot:item="data">
              <v-layout class="process-number" row>
                <span>{{ data.item.process_number }}</span>
                <v-spacer />
                <span class="folder-attached red--text" v-if="hasFolder(data.item)">APENSADO</span>
                <span class="folder-attached docgo--text" v-else>APENSAR</span>
              </v-layout>
            </template>
          </v-combobox>

          <v-layout column v-if="attachedFolders.length">
            <span class="subheading font-weight-bold my-2">Processos apensados:</span>

            <v-layout
              class="item mb-2"
              v-for="folder in attachedFolders"
              :key="folder.id"
              justify-center
              align-center
              row
            >
              <v-flex class="pa-2" xs5>
                <v-menu open-on-hover top offset-y style="width: 100%">
                  <v-layout class="folder-name" align-center row slot="activator">
                    <img
                      class="d-flex mx-3 folder-icon"
                      :src="folderIcon"
                      alt="Ícone de Pasta"
                    >
                    <v-layout column>
                      <v-flex class="grey--text">
                        <span class="caption">{{ folder.process_number }}</span>
                      </v-flex>
                      <v-flex class="font-weight-medium">
                        <span>{{ folder.folder_type.name }}</span>
                      </v-flex>
                    </v-layout>
                  </v-layout>

                  <v-card dark class="pa-2" v-if="folder.subject">
                    <span class="grey--text"> {{folder.subject}}</span>
                  </v-card>
                </v-menu>
              </v-flex>

              <v-flex class="pa-2" xs5>
                <v-chip color="grey-lighten-2">
                  <v-avatar size="16" color="white">
                    <v-icon size="16" color="grey">mdi-briefcase</v-icon>
                  </v-avatar>
                  <strong class="grey--text text--darken-2 text-truncate" style="max-width: 25ch">
                    {{ folder.entity.name }}
                  </strong>
                </v-chip>
              </v-flex>

              <v-flex class="pa-2 folder-action" xs1>
                <v-icon color="black" @click="openFolder(folder.id)">mdi-open-in-new</v-icon>
              </v-flex>

              <v-flex class="pa-2 folder-action" xs1>
                <v-icon color="black" @click="clickRemoveFolder(folder)">mdi-delete-outline</v-icon>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-text>

        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              flat
              @click="cancel"
            >
              Cancelar
            </v-btn>

            <v-btn
              dark
              color="black"
              @click="save"
            >
              Salvar
            </v-btn>
          </v-layout>
        </v-card-actions>
    </v-card>

    <remove-folder-dialog
      v-if="removeFolderDialog"
      :folder="selectedFolder"
      @removeFolder="removeFolder"
      @cancel="cancelRemoveFolder"
    />

    <loader-dialog :showLoader="loading" message="Carregando..." />
  </v-dialog>
</template>

<script>
import CurrentOwner from '@/components/inbox/CurrentOwner';
import TermComponent from '@/components/inbox/TermComponent';
import foldersService from '@/services/FoldersService';
import LoaderDialog from '@/components/LoaderDialog';
import RemoveFolderDialog from '@/components/folder/show/toolbar/action/RemoveFolderDialog';
import { isEmpty, cloneDeep } from 'lodash';

export default {
  name: 'attach-folder',
  props: ['folder'],
  components: {
    CurrentOwner,
    TermComponent,
    LoaderDialog,
    RemoveFolderDialog,
  },
  mounted() {
    this.getFolders();

    this.attachedFolders = cloneDeep(this.folder.attached_folders.folders);
    this.attachedFolders.map(folder => {
      folder.attached = true;
    });
  },
  data() {
    return {
      isEmpty,
      search: '',
      searchResult: null,
      dialog: false,
      loading: false,
      loadingSearch: false,
      folderIcon: '/static/images/folder/folder-open-icon.svg',
      removeFolderDialog: false,
      folders: [],
      selectedFolder: {},
      attachedFolders: [],
      removedFolders: [],
    }
  },
  computed: {
    userId() {
      return this.$store.getters.user.id;
    },
  },
  methods: {
    getFolders() {
      if (!this.userId) return;
      this.loadingSearch = true;

      foldersService
        .getEmployeeFolders({
          id: this.userId,
          page: 1,
          limit: 5,
          searchText: this.search || ''
        })
        .then(({ data }) => {
          // Verifica se data.folders existe, caso contrário usa um array vazio
          this.folders = data.folders || data.employee_folders || [];
          const CurrentFolder = this.folders.findIndex(folder => folder.id === this.folder.id);
          if (CurrentFolder !== -1) this.folders.splice(CurrentFolder, 1);
        })
        .finally(() => {
          this.loadingSearch = false;
        });
    },
    hasFolder(folder) {
      return this.attachedFolders.some(el => el.id === folder.id);
    },
    addFolder(folder) {
      this.$nextTick(() => {
        this.search = '';
        this.searchResult = null;
      });

      if(isEmpty(folder) || this.hasFolder(folder)) return;
      this.attachedFolders.push(folder);
    },
    openFolder(id) {
      const route = this.$router.resolve(`/pastas/${id}/show`);
      window.open(route.href, '_blank');
    },
    removeFolder(folder) {
      const attachedFolderIndex = this.attachedFolders.indexOf(folder);
      const selectedFolder = this.attachedFolders[attachedFolderIndex];

      if (selectedFolder.attached) {
        this.removedFolders.push(selectedFolder.id);
      }

      this.attachedFolders.splice(attachedFolderIndex, 1);
      this.removeFolderDialog = false;
    },
    clickRemoveFolder(folder) {
      this.selectedFolder = folder;
      this.removeFolderDialog = true;
    },
    cancelRemoveFolder() {
      this.selectedFolder = {};
      this.removeFolderDialog = false;
    },
    cancel() {
      this.attachedFolders = cloneDeep(this.folder.attached_folders.folders);
      this.attachedFolders.map(folder => {
        folder.attached = true;
      });
      this.dialog = false
    },
    save() {
      this.loading = true;
      const addFolders = this.attachedFolders.map(el => el.id).filter(Boolean);

      foldersService
        .attachFolders({
          folderId: this.folder.id,
          attachedFolders: addFolders,
          removedFolders: this.removedFolders,
        })
        .then(() => {
          this.$store.dispatch('getActiveFolder', { id: this.folder.id });

          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'success',
            message: 'Alteração dos processos apensados feita com sucesso',
            button: { show: true, text: 'Fechar', message: '' },
            timeout: 6000,
          });
        })
        .catch(() => {
          this.cancel();
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'red',
            message: 'Ocorreu um erro ao apensar processos',
            button: { show: true, text: 'Fechar', message: '' },
            timeout: 6000,
          });
        })
        .finally(() => {
          this.dialog = false;
          this.loading = false;
        });
    }
  },
  watch: {
    search() {
      clearInterval(this.interval);
      this.interval = setTimeout(() => {
        this.loadingSearch = true;
        this.getFolders();
      }, 500);
    },
  },
}
</script>

<style>
  .item {
    border: 1px solid #E0E0E0;
  }

  .folder-action {
    cursor: pointer;
  }

  .process-number {
    height: 100%;
    align-items: center;
  }

  .process-number:hover .folder-attached{
    display: block;
  }

  .folder-attached {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/folder/show/toolbar/action/AttachFolder.vue